export { Chatbot } from './lib/chatbot';
export type { ChatbotOptions } from './lib/chatbot';

// Expose on window so merchants can use it as a plain <script> tag
import { Chatbot } from './lib/chatbot';

declare global {
  interface Window {
    PaymobChatbot: typeof Chatbot;
  }
}

window.PaymobChatbot = Chatbot;
